<template>
  <!-- 新增社保 -->
  <div class="page_addCase">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/successCaseSet' }">文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>案例新增/编辑</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-form :model="formData" :inline="true" ref="caseForm" label-width="80px">
          <el-form-item label="客户名称" prop="CustomeName">
            <el-input v-model="formData.CustomeName"></el-input>
          </el-form-item>
          <el-form-item label="客户地区" prop="CustomeArea">
            <el-cascader ref="regAddress" :props="propsAddress" v-model="area" :options="provinces" filterable></el-cascader>
          </el-form-item>
          <el-form-item label="客户行业" prop="CustomerIndustry">
            <!-- <el-input v-model="formData.CustomerIndustry"></el-input> -->
            <el-cascader ref="industry" :props="propsTree" v-model="CustomerIndustry" :options="treeList" filterable :show-all-levels="false" @change="changeIndustry"></el-cascader>
          </el-form-item>
          <el-form-item label="签约主体" prop="ContractSubjectName">
            <el-select v-model="formData.ContractSubjectName" placeholder="" clearable filterable>
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称" prop="ProjectName">
            <el-input v-model="formData.ProjectName"></el-input>
          </el-form-item>
          <el-form-item label="业务类型" prop="BusiType" multiple collapse-tags>
            <el-select v-model="formData.BusiType" placeholder="" clearable>
              <el-option label="外包" value="外包"></el-option>
              <el-option label="派遣" value="派遣"></el-option>
              <el-option label="代理招聘" value="代理招聘"></el-option>
              <el-option label="猎头" value="猎头"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合作时间" prop="CooperationTime">
            <el-date-picker type="date" placeholder="选择日期" v-model="formData.CooperationTime"></el-date-picker>
          </el-form-item>
          <el-form-item label="合作状态" prop="CooperationStue">
            <el-select v-model="formData.CooperationStue" placeholder="" clearable>
              <el-option value="合作中"></el-option>
              <el-option value="已暂停"></el-option>
              <el-option value="已停止"></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="说明" prop="Details">
              <el-input type="textarea" v-model="formData.Details" :autosize="{ minRows: 4}"></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="附件">
              <div class="upload_box">
                <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
                  <el-button size="small" type="success">上传附件</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>

          <div class="btnBox">
            <el-button type="success" @click="submitForm" v-preventReClick>保存</el-button>
            <el-button @click="backHandle">取消</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        formData: {
          Id: '',
          CustomeName: '', //客户名称
          CustomeArea: '', //客户地区
          CustomerIndustry: '', //客户行业
          ContractSubjectName: '', //签约主体
          ProjectName: '', //项目名称
          BusiType: '', //业务类型
          CooperationTime: '', //合作时间
          CooperationStue: '', //合作状态
          Details: '', //详情
          DetailsFileName:'',//附件名称
          DetailsUrl:''
        },
        area: '',
        headPath: this.$store.state.EMP.docPath,
        CustomerIndustry: '', //行业
        provinces: [], //省列表
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children"
        },
        treeList: [], //行业列表
        legList: [], //主体列表
        propsTree: {
          label: "strParametername",
          value: "strParametername",
          children: "children",
          // checkStrictly: true
        },
        fileList: []
      };
    },
    created() {
      if (this.$route.query.row != undefined && this.$route.query.row) {
        this.formData = JSON.parse(this.$route.query.row);
        if (this.formData.CustomeArea != undefined && this.formData.CustomeArea) {
          this.area = this.formData.CustomeArea.split(',')
        }
        if (this.formData.CustomerIndustry != undefined && this.formData.CustomerIndustry) {
          this.CustomerIndustry = this.formData.CustomerIndustry.split(',')
        }
        if (this.formData.DetailsUrl) {
          let item = {
            Id: new Date().valueOf().toString() + Math.random(),
            name: this.formData.DetailsUrl,
            url: this.headPath + this.formData.DetailsUrl
          }
          this.fileList = [item]
        }
      }
      this.getprovinces();
      this.getTreestr(); //取行业列表
      this.getlegalsubjectlist(); //取主体
    },
    methods: {
      changeIndustry(val) {
        console.log(val)
        // this.$refs.industry._data.dropDownVisible = false;
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          this.provinces = res
        })
      },
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: '',
          keyword: ''
        }
        xz.getTreestr('JB_base_Custindust', data).then(res => {
          if (res) {
            this.treeList = res.msg.parent;
          } else {
            this.treeList = [];
          }
          this.treeLoading = false;
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      // 取消
      backHandle() {
        // window.close()
        this.$router.push({
          path: "/successCaseSet",
        });
      },
      submitForm() {
        this.$refs["caseForm"].validate((valid) => {
          if (valid) {
            if (!this.isNull(this.area)) {
              this.formData.CustomeArea = this.area.toString()
            }
            if (!this.isNull(this.CustomerIndustry)) {
              this.formData.CustomerIndustry = this.CustomerIndustry.toString()
            }
            xz.updatecustomecase(this.formData).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功')
                setTimeout(() => {
                  this.backHandle()
                }, 300);
              } else {
                this.$message.error('系统出错')
              }
            })
          }
        })
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formData.DetailsUrl = res;
            this.formData.DetailsFileName = file.name
          } else {
            this.formData.DetailsUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.formData.DetailsUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
    cursor: pointer;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 50px 0;
    width: 98%;
    display: flex;
    justify-content: center;
  }
</style>
<style>
  .page_addCase .el-input__inner {
    width: 221px;
  }

  .page_addCase .el-textarea__inner {
    width: 530px;
  }
</style>